import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/AdminUsers";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const AdminUser_VIEW = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMIN_USERS_FETCH_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.ADMIN_USERS_FETCH_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.ADMIN_USERS_FETCH_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        case actionTypes.ADMIN_USERS_FETCH_RESET:
            return {
                data: {},
                loading: false,
                success: false,
                error: null
            }
        default:
            return {...state}
    }
}

export default AdminUser_VIEW